import React from "react";
import "./HowItWorks.scss";

const HowItWorks = () => {
  return (
    <section className="howDreams" id="como-funciona">
      <div className="container">
        <div className="howDreams__header">
          <span className="howDreams__tag">Es muy fácil comenzar</span>

          <h2>¿Cómo funciona Dreams XV?</h2>

          <p>
            Encuentra todo para tus XV años de forma simple, visual y rápida.
            Solo explora, elige y conecta con los proveedores que más te gusten.
          </p>
        </div>

        <div className="howDreams__grid">
          <div className="howDreams__card">
            <div className="howDreams__number">01</div>
            <div className="howDreams__icon">🔍</div>
            <h3>Explora proveedores</h3>
            <p>
              Recorre categorías y descubre opciones para vestidos, maquillaje,
              fotografía, salones, pasteles y mucho más.
            </p>
          </div>

          <div className="howDreams__card">
            <div className="howDreams__number">02</div>
            <div className="howDreams__icon">💛</div>
            <h3>Elige tus favoritos</h3>
            <p>
              Guarda las ideas que más te inspiren y enfócate en los servicios
              que realmente encajan con la fiesta que imaginas.
            </p>
          </div>

          <div className="howDreams__card">
            <div className="howDreams__number">03</div>
            <div className="howDreams__icon">📲</div>
            <h3>Contáctalos directamente</h3>
            <p>
              Conecta con los proveedores que más te interesen para pedir
              información, cotizar y comenzar a planear.
            </p>
          </div>

          <div className="howDreams__card">
            <div className="howDreams__number">04</div>
            <div className="howDreams__icon">✨</div>
            <h3>Haz realidad tu fiesta</h3>
            <p>
              Organiza tu evento con más claridad, inspiración y confianza para
              vivir unos XV años inolvidables.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;